import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {Observable} from 'rxjs';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {AppUrl} from '../constants/app-url';

@Injectable({
  providedIn: 'root'
})
export class StatusService extends BaseService {
  constructor(public http: HttpClient,
              public alertService: AlertService,
              public globalService: GlobalService) {
    super(http, alertService, globalService);
  }

  create(data): Observable<any> {
    return this.postRequest(AppUrl.STATUSES(), data);
  }

  get(data): Observable<any> {
    return this.getRequest(AppUrl.STATUSES(), data);
  }

  detail(id): Observable<any> {
    return this.getRequest(AppUrl.STATUSES(id));
  }

  update(id, data): Observable<any> {
    return this.putRequest(AppUrl.STATUSES(id), data);
  }

  updateStatus(id, data): Observable<any> {
    return this.putRequest(AppUrl.STATUS_STATUS(id), data);
  }
}
